import { Bike, Car, Truck, FileText, Package, Box, CreditCard, Banknote, Wallet } from "lucide-react";

// Vehicle types with pricing
export const vehicleTypes = [
  {
    id: "bike",
    name: "Bike",
    icon: Bike,
    maxWeight: 5,
    description: "Up to 5kg",
    basePrice: 49,
    perKmPrice: 8,
    eta: "15-25 min",
    color: "bg-green-500"
  },
  {
    id: "car",
    name: "Car",
    icon: Car,
    maxWeight: 20,
    description: "Up to 20kg",
    basePrice: 99,
    perKmPrice: 14,
    eta: "20-35 min",
    color: "bg-blue-500"
  },
  {
    id: "van",
    name: "Van",
    icon: Truck,
    maxWeight: 100,
    description: "Up to 100kg",
    basePrice: 199,
    perKmPrice: 20,
    eta: "30-45 min",
    color: "bg-orange-500"
  }
];

// Package categories
export const packageCategories = [
  { id: "documents", name: "Documents", icon: FileText, maxWeight: 1, suggestedVehicle: "bike" },
  { id: "small", name: "Small Parcel", icon: Package, maxWeight: 5, suggestedVehicle: "bike" },
  { id: "medium", name: "Medium", icon: Box, maxWeight: 20, suggestedVehicle: "car" },
  { id: "large", name: "Large", icon: Truck, maxWeight: 100, suggestedVehicle: "van" }
];

// Payment methods
export const paymentMethods = [
  { id: "online", name: "Pay Online", description: "5% OFF", icon: CreditCard, discount: 5 },
  { id: "cod", name: "Cash", description: "+₹20", icon: Banknote, extraCharge: 20 },
  { id: "pay_later", name: "Pay Later", description: "+₹10", icon: Wallet, extraCharge: 10 }
];

// Google OAuth helper
export const getGoogleAuthUrl = () => {
  const redirectUrl = window.location.origin + '/';
  return `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
